export default __webpack_public_path__ + "static/media/se.2c17c00b.svg";